import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { MexGridPageDataService } from "../mex-grid-page-data.service";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { NzConfigService } from "ng-zorro-antd/core/config";
import { colorLuminance } from "src/app/utils/common";

import {
  VAIconRegistryService,
  check,
  close,
  fileContract,
  flag,
} from "@va/core-library/icons";

@Component({
  selector: "app-research-insight-popup",
  templateUrl: "./research-insight-popup.component.html",
  styleUrls: ["./research-insight-popup.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ResearchInsightPopupComponent implements OnInit {
  @Input() ticker = "";
  @Input() dapParamObj: any = null;
  @Input() showPopup = false;
  @Output() closePopup = new EventEmitter();
  lineItemName = "";
  documentsList: Array<any> = [];
  allDocumentsList: Array<any> = [];
  sentencesList: Array<any> = [];
  loading = true;
  loadingSentences = true;
  styleObj: any;
  maskObj: any;
  modalWidth = "";
  modalHeight = "";
  currentDocument: any = {
    document_id: 0,
  };
  currentDocumentLink = "";
  totalReports = 0;
  pageNo = 0;
  pageSize;
  title = "Research Snippets";
  constructor(
    protected mexService: MexGridPageDataService,
    protected notification: NzNotificationService,
    protected nzConfigService: NzConfigService,
    protected iconRegistry: VAIconRegistryService,
  ) {
    this.nzConfigService.set("notification", {
      nzPlacement: "topRight",
    });
    this.iconRegistry.registerIcons([check, close, fileContract, flag]);
  }

  ngOnInit() {
    this.maskObj = {
      opacity: 0,
      "background-color": "transparent",
    };
    this.pageSize = 15;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.showPopup && changes.showPopup.currentValue === true) {
      this.documentsList = [];
      this.pageNo = 0;
      this.sentencesList = [];
      this.loading = true;
      this.loadingSentences = true;
      this.currentDocument = null;
      this.currentDocumentLink = "";
      this.totalReports = 0;
      this.getAllDocuments();
    }
  }
  @HostListener("window:resize", [])
  sizeResearchChange() {
    const windowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
    this.styleObj = {
      height: `${windowSize.height - 85}px`, //header height
    };
  }
  closeModal() {
    this.showPopup = false;
    this.closePopup.emit(false);
  }

  getAllDocuments() {
    if (this.allDocumentsList.length === 0) {
      const payload = {
        ticker: this.ticker,
        page_no: this.pageNo,
        page_size: 30,
        mtag: [],
        ctag: [],
      };

      this.mexService
        .getResearchDocumentsForDp(payload)
        .subscribe((resp: any) => {
          if (resp.status === "success") {
            this.allDocumentsList = [...resp.documents_data.documents];
            this.getDocumentData();
          }
        });
    } else {
      this.getDocumentData();
    }
  }
  updateDocumentList(docList) {
    const arr1 = [...this.allDocumentsList];

    const unique = arr1.map((val) => {
      const newObj = docList.filter(
        (item) => item.document_id === val.document_id,
      );
      if (newObj.length) {
        return newObj[0];
      }
      return val;
    });
    this.allDocumentsList = unique;
  }

  getDocumentData() {
    const payload = {
      ticker: this.ticker,
      dapparameterid: this.dapParamObj.dapparameterid,
      masterparameterid: this.dapParamObj.masterparameterid,
      parameterid: this.dapParamObj.parameterid,
      page_no: this.pageNo,
      page_size: 30,
      mtag: this.dapParamObj.mtag,
      ctag: this.dapParamObj.ctag,
    };

    this.mexService.getResearchDocumentsForDp(payload).subscribe(
      (resp: any) => {
        if (resp.status === "success") {
          this.documentsList.push(
            ...resp.documents_data.documents.map((val) => val.document_id),
          );

          this.loading = false;
          this.updateDocumentList(resp.documents_data.documents);
          if (this.pageNo === 0) {
            this.totalReports = resp.documents_data.total_document_count;
            this.lineItemName = resp.documents_data.dapparametername;
            this.selectDocument(resp.documents_data.documents[0]);
          }
        } else {
          this.notification.error(
            this.title,
            "Something went wrong while fetching data. Please try again later!",
          );
          this.loading = false;
        }
      },
      (err) => {
        this.loading = false;
        this.notification.error(
          this.title,
          `Something went wrong while fetching data. Please try again later!${err}`,
        );
      },
    );
  }
  selectDocument(doc) {
    if (!this.documentsList.includes(doc.document_id)) {
      return;
    }
    this.currentDocument = { ...doc };
    this.currentDocumentLink = doc.document_url;
    this.sentencesList = [];
    this.getSentenceData();
  }
  getSentenceData() {
    this.loadingSentences = true;
    const params = {
      ticker: this.ticker,
      masterParameterId: this.dapParamObj.masterparameterid,
      parameterid: this.dapParamObj.parameterid,
      documentId: this.currentDocument.document_id,
      mtag: this.dapParamObj.mtag,
      ctag: this.dapParamObj.ctag,
    };
    this.mexService.getSentenceInstances(params).subscribe(
      (resp: any) => {
        if (resp.status === "success") {
          this.sentencesList = resp.sentence_details.sentences.map((item) => {
            const option =
              item.last_user_selection === 1
                ? "Yes"
                : item.last_user_selection === 2
                  ? "No"
                  : "";
            item["showClear"] = option !== "";
            item["optionSelected"] = option;

            item["org_sentence_text"] = item.sentence_text;
            let index = 0;
            let newHtmlSentence = "";
            const wordArr = [];
            const reasearchText = item.sentence_text;
            item["highlights"].forEach(function (pos) {
              if (
                reasearchText.length > pos[0] &&
                reasearchText.length >= pos[1]
              ) {
                wordArr.push(reasearchText.substring(index, pos[0]));
                wordArr.push(
                  `<span class='highlights-text'>${reasearchText.substring(
                    pos[0],
                    pos[1],
                  )}</span>`,
                );
                index = pos[1];
              }
            });
            wordArr.push(reasearchText.substring(index));
            wordArr.forEach(function (item) {
              newHtmlSentence = newHtmlSentence + item;
            });
            if (newHtmlSentence !== "") {
              item.sentence_text = newHtmlSentence;
            }
            item["polarityColor"] = this.getPolarityColor(item.polarity);

            return item;
          });
          this.loadingSentences = false;
        } else {
          this.notification.error(
            this.title,
            "Something went wrong while fetching data. Please try again later!",
          );
          this.loadingSentences = false;
        }
      },
      (err) => {
        this.notification.error(
          this.title,
          `Something went wrong while fetching data. Please try again later!${err}`,
        );
        this.loadingSentences = false;
      },
    );
  }
  onScroll() {
    if (this.totalReports > this.documentsList.length) {
      this.pageNo++;
      this.getAllDocuments();
    }
  }
  clearSelection(sentenceId) {
    const currentSent = this.sentencesList.filter(
      (val) => val.sentence_id === sentenceId,
    )[0];
    currentSent.showClear = false;
    currentSent.optionSelected = "";
    this.setUserSelection(currentSent);
  }
  setYes(sentenceId) {
    const currentSent = this.sentencesList.filter(
      (val) => val.sentence_id === sentenceId,
    )[0];
    if (currentSent.optionSelected === "Yes") {
      this.clearSelection(sentenceId);
      return;
    }
    currentSent.showClear = true;
    currentSent.optionSelected = "Yes";
    this.setUserSelection(currentSent);
  }
  setNo(sentenceId) {
    const currentSent = this.sentencesList.filter(
      (val) => val.sentence_id === sentenceId,
    )[0];
    if (currentSent.optionSelected === "No") {
      this.clearSelection(sentenceId);
      return;
    }
    currentSent.showClear = true;
    currentSent.optionSelected = "No";
    this.setUserSelection(currentSent);
  }
  setUserSelection(obj) {
    let userSelection = 0;
    if (obj.optionSelected === "Yes") {
      userSelection = 1;
    }
    if (obj.optionSelected === "No") {
      userSelection = 2;
    }
    if (obj.optionSelected === "") {
      userSelection = 3;
    }
    const payload = {
      ticker: this.ticker,
      masterparameterid: this.dapParamObj.masterparameterid,
      sentencepredictionsidentifier: obj.sentencepredictionsidentifier,
      dapparameterid: this.dapParamObj.dapparameterid,
      sentence_rank: obj.sentence_rank,
      document_rank: this.currentDocument.document_rank,
      user_selection: userSelection,
    };
    this.mexService
      .setUserSelectionForInstance(payload)
      .subscribe((resp: any) => {
        if (resp.status === "success")
          this.notification.success(this.title, "User selection saved!");
        else
          this.notification.error(
            this.title,
            "Something went wrong while saving your response. Please try again later!",
          );
      });
  }
  getPolarityColor(polarity) {
    let bgColor = "#FFC846";
    if (polarity < -0.25) {
      // get colorLuminance for red
      bgColor = colorLuminance("#B40000", Math.abs(polarity));
    } else if (polarity >= -0.25 && polarity <= 0.25) {
      bgColor = colorLuminance("#FFC846", Math.abs(polarity));
    } else {
      bgColor = colorLuminance("#006800", Math.abs(polarity));
    }
    return bgColor;
  }
}
